import { render, staticRenderFns } from "./reconovaPagination.vue?vue&type=template&id=48c336ce&scoped=true&"
import script from "./reconovaPagination.vue?vue&type=script&lang=js&"
export * from "./reconovaPagination.vue?vue&type=script&lang=js&"
import style0 from "./reconovaPagination.vue?vue&type=style&index=0&id=48c336ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c336ce",
  null
  
)

export default component.exports